import { Divider } from "antd";
import React from "react";
import { SVGicon } from "../../SVGicon/SVGicon";

const ColorDetails = [
    {
        colorType: "Theme Color",
        colorData: [
            { colorCode: "#F4A534", colorVariable: "--color-prime: ", colorFrontClass: "text-color-prime", colorBackClass: "ground-color-prime" },
            { colorCode: "#365FB2", colorVariable: "--color-berry: ", colorFrontClass: "text-color-berry", colorBackClass: "ground-color-berry" },
            { colorCode: "#36B24B", colorVariable: "--color-earth: ", colorFrontClass: "text-color-earth", colorBackClass: "ground-color-earth" },
            { colorCode: "#CC563E", colorVariable: "--color-grace: ", colorFrontClass: "text-color-grace", colorBackClass: "ground-color-grace" },
        ],
    },
    {
        colorType: "Gray Scale Color",
        colorData: [
            { colorCode: "#393E40", colorVariable: "--color-alpha: ", colorFrontClass: "text-color-alpha", colorBackClass: "ground-color-alpha" },
            { colorCode: "#737B7F", colorVariable: "--color-bravo: ", colorFrontClass: "text-color-bravo", colorBackClass: "ground-color-bravo" },
            { colorCode: "#A1ADB2", colorVariable: "--color-cache: ", colorFrontClass: "text-color-cache", colorBackClass: "ground-color-cache" },
            { colorCode: "#E3E5E5", colorVariable: "--color-delta: ", colorFrontClass: "text-color-delta", colorBackClass: "ground-color-delta" },
            { colorCode: "#F5F8FA", colorVariable: "--color-ashes: ", colorFrontClass: "text-color-ashes", colorBackClass: "ground-color-ashes" },
        ],
    },
]

export const StyledColorsSHB = () => {
    return (
        <>
            <div>
                {ColorDetails.map((colorItems, colorIndex) => (
                    <div key={colorIndex} className="styled-color-margin">
                        <Divider orientation="left">{colorItems.colorType}</Divider>

                        <div className="styled-color-grid">
                            {colorItems.colorData.map((colorDataItems, colorDataIndex) => (
                                <div key={colorDataIndex} className="styled-color-item">
                                    <div className={`styled-color-placeholder flex-center ${colorDataItems.colorBackClass}`}>
                                        <span className="flex-center flex-auto-0 contain-image pointer">
                                            {SVGicon.mtpIconCopy}
                                        </span>
                                    </div>
                                    <div className="styled-color-information">
                                        <p className="styled-color-info-code">
                                            <span className="copy-to-clipboard-button flex-center flex-auto-0 contain-image"> {SVGicon.mtpIconCopy}</span>
                                            <span className="style-color-info-text"> {colorDataItems.colorCode}</span>
                                        </p>
                                        <p className="styled-color-info-variable">
                                            <span className="copy-to-clipboard-button flex-center flex-auto-0 contain-image"> {SVGicon.mtpIconCopy}</span>
                                            <span className="style-color-info-text"> {colorDataItems.colorVariable}</span>
                                        </p>
                                        <p className="styled-color-info-back-class">
                                            <span className="copy-to-clipboard-button flex-center flex-auto-0 contain-image"> {SVGicon.mtpIconCopy}</span>
                                            <span className="style-color-info-text"> {colorDataItems.colorBackClass}</span>
                                        </p>
                                        <p className="styled-color-info-front-class">
                                            <span className="copy-to-clipboard-button flex-center flex-auto-0 contain-image"> {SVGicon.mtpIconCopy}</span>
                                            <span className="style-color-info-text"> {colorDataItems.colorFrontClass}</span>
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                ))}
            </div>
        </>
    )
}